import { saveProject } from '@/utils/postmessages';
import { generateNotification } from '@/libs/generateNotification';
import { updateImagesOnConfigurationChange } from '@/libs/updateImagesOnConfigurationChange';
import { useStoreNotifications } from '@/Store/storeNotifications';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';

export function saveCase() {
    updateImagesOnConfigurationChange();
    useStoreProjectStructure().updateCaseDataSelected();
    saveProject();
    // useStoreNotifications()
    //     .addNotification(generateNotification('projectSaved','Проект успешно сохранён!'), 2);
}
